import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const data = [
  { name: 'Katie R.', text: 'Fast response during a heat wave—AC repaired the same day. Clear pricing and super polite.', location: 'Bloomington IN' },
  { name: 'James & Priya', text: 'They replaced our aging furnace and added a smart thermostat. Our bills dropped immediately.', location: 'Ellettsville IN' },
  { name: 'Marta L. (Property Manager)', text: 'Reliable commercial maintenance—fewer emergency calls and happier tenants.', location: 'Bloomington IN' }
];

export default function Testimonials() {
  return (
    <Grid container spacing={3}>
      {data.map((t, i) => (
        <Grid item xs={12} md={4} key={i}>
          <Box sx={{ p: 3, border: '1px solid #eee', borderRadius: 2, height:'100%' }}>
            <FormatQuoteIcon color="primary" />
            <Typography variant="body1" sx={{ my: 1 }}>"{t.text}"</Typography>
            <Typography variant="subtitle2">— {t.name}, {t.location}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
